import PropTypes from 'prop-types';
import * as queryString from 'query-string';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
  selectMediaTypeSearchTabs,
  selectMediaTypeSearchBrowseText,
  selectMediaTypeSearchBrowseUrlArgs,
} from '../../../MediaTypeSearch/selectors/mediaTypeSearchSelectors';
import { buildRequestUrl } from '../../utils';
import MediaGridItem from './MediaGridItem';
import MediaGridNavBar from './MediaGridNavBar';

// TODO: Convert to TS when there is more time OMFG-1016 and TOFU-431, but if you see this, feel free to convert it too.
class MediaGridContainer extends Component {
  static propTypes = {
    browseText: PropTypes.string,
    browseUrlArgs: PropTypes.string,
    collections: PropTypes.array,
  };

  constructor(props) {
    super(props);
    const { collections } = props;
    const firstCollection = collections[0];
    this.state = {
      selectedMediaCollection:
        firstCollection && firstCollection.collectionName
          ? firstCollection.collectionName
          : null,
      selectedMediaItems:
        firstCollection && firstCollection.items ? firstCollection.items : null,
      selectedMediaUrl:
        firstCollection && firstCollection.url ? firstCollection.url : null,
    };
  }

  static defaultProps = {
    browseText: '',
    browseUrlArgs: '',
  };

  render() {
    const { collections } = this.props;
    const { selectedMediaCollection, selectedMediaItems } = this.state;
    return (
      <div className="mediaGridContainer">
        <MediaGridNavBar
          collections={collections}
          onSelect={(collectionName) => this.selectCollection(collectionName)}
          selectedMediaCollection={selectedMediaCollection}
        />
        <div className="mediaGridContent">
          <ul className="mediaGridContent-contentList">
            {collections.map((collection) => {
              const { collectionName, items } = collection;
              return items.map((item) => {
                const itemProps = item;
                const { url, isVideo, previewUrl } = item;
                const isFirst = selectedMediaItems[0]?.url === url;

                //Checks if the item is part of the currently selected collection and
                //if it's a video that it has a source (previewUrl) before rendering
                return selectedMediaCollection === collectionName &&
                  (!isVideo || (isVideo && previewUrl)) ? (
                  <MediaGridItem
                    key={`mediaGridItem-${url}`}
                    collectionName={collectionName}
                    shouldDisplay={true}
                    isFirst={isFirst}
                    {...itemProps}
                  />
                ) : null;
              });
            })}
          </ul>
        </div>
        {this.renderBrowseLibraryLink()}
      </div>
    );
  }

  renderBrowseLibraryLink() {
    const { browseText, browseUrlArgs } = this.props;
    const { selectedMediaUrl } = this.state;

    const mediaUrl = buildRequestUrl(
      selectedMediaUrl,
      queryString.parse(browseUrlArgs)
    );
    return (
      <a
        className="mediaGridContainer-browseLink btn btn-default"
        href={mediaUrl}
      >
        {browseText ? browseText : 'Browse Our Library'}
      </a>
    );
  }

  selectCollection = (collectionName) => {
    const { collections } = this.props;
    const selectedCollection = collections.find(
      (collection) => collection.collectionName === collectionName
    );
    this.setState({
      selectedMediaCollection: collectionName,
      selectedMediaItems: selectedCollection.items,
      selectedMediaUrl: selectedCollection.url,
    });
  };
}

function mapStateToProps(state) {
  const collections = selectMediaTypeSearchTabs(state);

  collections.forEach((collection) => {
    const { items } = collection;
    if (!Array.isArray(items)) {
      collection.items = Object.values(items);
    }
  });

  return {
    collections,
    browseText: selectMediaTypeSearchBrowseText(state),
    browseUrlArgs: selectMediaTypeSearchBrowseUrlArgs(state),
  };
}

export default connect(mapStateToProps)(MediaGridContainer);
